import Order from './order';

import {
  getAngleBy2XY,
  getDistanceBy2XY,
  getDiffBetween2Angles,
} from '../../utils/geometry';

export interface MoveToOrderParams {
  x?: number;
  y?: number;
}

export default class MoveToOrder extends Order implements MoveToOrderParams {
  constructor(params: MoveToOrderParams) {
    super();
    if (params.x && params.y) {
      this.x = params.x;
      this.y = params.y;
    }


    this.color = 'green';
  }

  update(modifier: number): MoveToOrder {
    if (this.getElement()?.moveSpeedMax === 0) // can't move: "Game over man, game over!"
      return this;

    const element = this.getElement();
    const {
      x,
      y,
    } = element;

    const destinationAngle = getAngleBy2XY({
      x1: x,
      y1: y,
      x2: this.x,
      y2: this.y,
    });
    if (getDiffBetween2Angles(element.lookAngle, destinationAngle) > 1) // fixing a bug that caused slow turning ships to "shake"
      element.moveAngle = element.rotateTowardsAngle(destinationAngle, modifier);

    /* brake if element has to do a U-turn hard */
    if (getDiffBetween2Angles(element.moveAngle, destinationAngle) >= 45)
      element.brake(modifier);
    else
      element.accelerate(modifier);

    /* Reach the objective, don't overshoot it */
    if (this.isComplete(modifier)) {
      element.x = this.x;
      element.y = this.y;
    }

    return this;
  }

  onComplete(): void {
    if (this.isLastOrder())
      this.getElement().stop();
  }

  isComplete(modifier: number): boolean {


    /* element is gonna overshoot its destination */
    const distanceToObjective = getDistanceBy2XY({
      x1: this.behaviour.element.x,
      y1: this.behaviour.element.y,
      x2: this.x,
      y2: this.y,
    });
    return (distanceToObjective < this.getElement().moveSpeed * 2 * modifier);
  }

  isPossible(): boolean {
    return (this.getElement()?.moveSpeedMax > 0); // can't move: "Game over man, game over!"
  }
}
